import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($scope, $q, LocaleService, GeoCodeService, TranslateService, claimViewModel) => {
    const ctrl = Object.create(BaseCtrl);
    const newVehicle = {
        placeholder: true
    };

    ctrl.init = () => {
        $scope.claimVm = claimViewModel();
        $scope.vehicleIncidentsVm = $scope.claimVm.lobs.commercialAuto.vehicleIncidents;
        $scope.theftCodes = {
            'theftentire': _.find($scope.claimVm.lossCause.aspects.availableValues, {
                code: 'theftentire'
            }),
            'theftparts': _.find($scope.claimVm.lossCause.aspects.availableValues, {
                code: 'theftparts'
            })
        };
        $scope.vehicleIncidentsVm.forEach(vi => {
            vi.theft.value = _.values($scope.theftCodes).includes($scope.claimVm.lossCause.value);
        });
        $scope.vehicleIncidentsVm.forEach(vi => {
            vi.safeToDrive.value = false;
        });
    };

    ctrl.defineWatches = () => {
        $scope.$watch('fnol.newMapCenter', (newCenter) => {
            if (newCenter !== undefined) {
                const result = GeoCodeService.getGeoCodedAddr(newCenter.latitude, newCenter.longitude);
                $q.when(result, (address) => {
                    $scope.claimVm.lossLocation.value = address;
                });
            }
        }, true);
    };

    ctrl.getAvailableVehicles = () => {
        const result = $scope.vehicleIncident.value.availableVehicles();
        result.push(newVehicle);
        return result;
    };

    ctrl.vehicleName = (vehicle) => {
        return vehicle.placeholder ?
            TranslateService.instant('fnol.ca.directives.vehicle-incident.Other Vehicle') :
            vehicle.getDisplayName(TranslateService.instant('fnol.ca.directives.vehicle-incident.New Vehicle'));
    };

    ctrl.next = (flowNextFn, form) => {
        if (form.invalid) {
            if ($scope.fnol.lossLocationType === 'map') {
                $scope.fnol.lossLocationType = 'city_only';
            }
        }
        return flowNextFn($scope.claimVm);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$q', 'LocaleService', 'GeoCodeService', 'TranslateService', 'claimViewModel'];

export default fn;
